<div class="api-card">
  <div class="api-card__header">
    <div class="api-card__header-stack">
      <span class="api-card__title">Recent transactions</span>
      <span class="api-card__desc">Top-ups, grants and refunds on your wallet.</span>
    </div>
  </div>

  @if (items.length) {
    <app-txn-table [rows]="rows" [showStatus]="true"></app-txn-table>
  } @else {
    <div class="empty-state">
      <p class="empty-state__title">No transactions yet.</p>
      <p class="empty-state__desc">Your first top-up will show up here.</p>
    </div>
  }

  <div class="api-card__footer">
    <a routerLink="/billing/transactions" class="link">
      View all transactions
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M4.5 2.5L8 6L4.5 9.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </a>
  </div>
</div>
